import {create} from 'zustand';

/**
 * Zustand store for the Marimo panel.
 *
 * These states are not stored on the panel config because they should reset
 * when the page is reloaded.
 * This state needs to be accessible from both the marimo panel and the marimo settings drawer.
 */

export enum MarimoMode {
  STATIC = 'static',
  RUN = 'run',
}

const DEFAULT_PANEL_STATE: MarimoPanelState = {
  mode: MarimoMode.STATIC,
  url: undefined,
  sandboxId: undefined,
  token: undefined,
  runNames: [],
};

type MarimoPanelState = {
  mode: MarimoMode;
  url: string | undefined;
  sandboxId: string | undefined;
  token: string | undefined;
  runNames: string[];
};

type MarimoState = {
  panels: Partial<Record<string, MarimoPanelState>>;
} & {
  setPanelState: (panelId: string, state: Partial<MarimoPanelState>) => void;
  getPanelState: (panelId: string) => MarimoPanelState;
};

export const useMarimoState = create<MarimoState>((set, get) => ({
  panels: {},
  getPanelState: (panelId: string) =>
    get().panels[panelId] ?? DEFAULT_PANEL_STATE,
  setPanelState: (panelId: string, newState: Partial<MarimoPanelState>) =>
    set(state => ({
      panels: {
        ...state.panels,
        [panelId]: {
          ...DEFAULT_PANEL_STATE,
          ...state.panels[panelId],
          ...newState,
        },
      },
    })),
}));
